import React, { useEffect, useRef, useState } from "react";
import BringIdeas from "../../PortfolioPage/BringIdeas/BringIdeas";
import Banner1 from "../../Homepage/Banner1/Banner1";
import Appointment from "../../Homepage/Appointment/Appointment";
import FooterAll from "../../Homepage/FooterAll/FooterAll";
import Footer from "../../Homepage/Footer/Footer";
import CaseStudiesNavbar from "../CaseStudiesNavbar/CaseStudiesNavbar";
import Navbarsynergtech from "../../Homepage/Navbarsynergtech/Navbarsynergtech";
import CaseStudy from "../CaseStudy/CaseStudy";
import "./../CaseStudiesMerge/Casestudynavbar.css";
import { Helmet } from 'react-helmet';

function CaseStudiesMerge() {
  const appointmentRef = useRef(null);

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // A scrollToAppointment() call used to run here on mount: it threw every visitor to the bottom of the
    // page on load and made the prerender snapshot capture the scrolled-state "back to top" button.

    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div>
      <>
        {isVisible && (
          <button onClick={scrollToTop} className="scroll-to-top-button">
            <span>↑</span>
          </button>
        )}
      </>
      <Helmet>
        <meta property="og:title" content="Case Studies: AI, Cloud & Software | 360 SynergyTech" />
        <meta property="og:url" content="https://360synergytech.com/case-studies" />
        <meta property="og:image" content="https://360synergytech.com/synergy-logo.png" />
        <meta property="og:description" content="Read case studies of how 360 SynergyTech delivered innovative IT, AI, and cloud solutions that transformed businesses worldwide." />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Case Studies: AI, Cloud & Software | 360 SynergyTech" />
        <meta name="twitter:description" content="Real business success stories powered by 360 SynergyTech." />
        <meta name="twitter:image" content="https://360synergytech.com/synergy-logo.png" />
        <title>Case Studies: AI, Cloud & Software | 360 SynergyTech</title>
        <meta name="description" content="Discover how 360 SynergyTech helped businesses grow with AI, cloud, and automation solutions in our detailed case studies." />
        
        <link rel="canonical" href="https://360synergytech.com/case-studies" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://360synergytech.com/" },
              { "@type": "ListItem", position: 2, name: "Case Studies", item: "https://360synergytech.com/case-studies" },
            ],
          })}
        </script>
      </Helmet>
      <Navbarsynergtech scrollToAppointment={scrollToAppointment} />
      <CaseStudiesNavbar />
      <CaseStudy />
      <BringIdeas scrollToAppointment={scrollToAppointment} />
      <Banner1 />
      <div ref={appointmentRef}>
        <Appointment />
      </div>
      <FooterAll />
      <Footer />
    </div>
  );
}

export default CaseStudiesMerge;